export function markErrorAsExpected(error) {
  if (!error || !["function", "object"].includes(typeof error)) return;

  try {
    error.expected = true;
    error.name = "ExpectedApiError";
  } catch {
    // Provider-level filters remain a best-effort safeguard for immutable errors.
  }
}

export function isExpectedPostHogException(event) {
  if (event.properties?.expected === true) return true;

  return event.properties?.$exception_list?.some(
    (exception) =>
      exception.type === "ExpectedApiError" ||
      String(exception.value || "").startsWith(
        "'ExpectedApiError' captured as exception"
      )
  );
}
